import { useState, useEffect } from "react";
import {
  BUSINESS_TYPES,
  BUSINESS_TAGS,
  MAX_TAG_SELECTIONS,
  generateServicesFromTags,
  getBusinessType,
} from "../data/businessTypeConfig";
import axios from "axios";
import { BASE_URL } from "../config";
import styles from "../styles/tagSelect.module.css";

const TagSelect = ({ onNext, onBack, stepData }) => {
  // Get businessType from stepData or localStorage
  const businessType =
    stepData?.businessType || localStorage.getItem("businessType") || "other";

  const type = getBusinessType(businessType);
  const tags = BUSINESS_TAGS[businessType] || [];
  const [selected, setSelected] = useState([]);
  const [saving, setSaving] = useState(false);

  // REDIRECT IF NO TOKEN
  useEffect(() => {
    const token = localStorage.getItem("auth_token");
    if (!token && onBack) onBack();
  }, []);

  const toggleTag = (tagId) => {
    setSelected((prev) => {
      if (prev.includes(tagId)) return prev.filter((t) => t !== tagId);
      if (prev.length >= MAX_TAG_SELECTIONS) return prev;
      return [...prev, tagId];
    });
  };

  const handleContinue = async () => {
    if (selected.length === 0) return;
    setSaving(true);

    // Save tags to backend
    try {
      const businessId = localStorage.getItem("business_id");
      const authToken = localStorage.getItem("auth_token");

      await axios.put(
        `${BASE_URL}/business/update_profile_info`,
        {
          id: businessId,
          businessTags: selected,
        },
        { headers: { Authorization: authToken } }
      );
    } catch (e) {
      console.log("Tag save error:", e);
    }

    // Generate services from selected tags and pass to create-service
    const services = generateServicesFromTags(selected);
    localStorage.setItem("generatedServices", JSON.stringify(services));
    setSaving(false);
    onNext();
  };

  const handleSkip = () => {
    onNext();
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        {/* Type icon */}
        {type && (
          <div
            className={styles.typeIconBig}
            style={{
              background: type.color + "15",
              borderColor: type.color,
            }}
          >
            <span>{type.emoji}</span>
          </div>
        )}

        <h2 className={styles.title}>מה מתאר את העסק שלך?</h2>
        <p className={styles.subtitle}>
          נתאים לך שירותים מומלצים לפי הבחירה
        </p>
        <p className={styles.subtitleSmall}>
          (עד {MAX_TAG_SELECTIONS} בחירות)
        </p>

        {/* Tags grid */}
        <div className={styles.tagsWrap}>
          {tags.map((tag) => {
            const isActive = selected.includes(tag.id);
            return (
              <div
                key={tag.id}
                className={`${styles.tagChip} ${
                  isActive ? styles.tagChipActive : ""
                }`}
                style={
                  isActive
                    ? {
                        borderColor: type?.color,
                        background: type?.color + "0d",
                      }
                    : {}
                }
                onClick={() => toggleTag(tag.id)}
              >
                <span className={styles.tagEmoji}>{tag.emoji}</span>
                <span
                  className={styles.tagName}
                  style={
                    isActive
                      ? { color: type?.color, fontWeight: "700" }
                      : {}
                  }
                >
                  {tag.name}
                </span>
              </div>
            );
          })}
        </div>

        {selected.length > 0 && (
          <p className={styles.counter}>
            {selected.length} / {MAX_TAG_SELECTIONS}
          </p>
        )}
      </div>

      {/* Footer */}
      <div className={styles.footer}>
        <div className={styles.footerInner}>
          <button
            className={styles.continueBtn}
            onClick={handleContinue}
            disabled={selected.length === 0 || saving}
          >
            {saving ? "שומר..." : "המשך"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TagSelect;
